import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import "./Heeader.css";
import { useAuth } from "./security/Authcontext";

const Header = () => {
  const authContext = useAuth();
  const navigate = useNavigate();
  const isAuthenticated = authContext.isAuthenticated;
  const username = authContext.usrname || "User";

  const [openMenu, setOpenMenu] = useState(false);
  const [darkMode, setDarkMode] = useState(
    localStorage.getItem("theme") !== "light"
  );

  useEffect(() => {
    document.documentElement.setAttribute(
      "data-theme",
      darkMode ? "dark" : "light"
    );
    localStorage.setItem("theme", darkMode ? "dark" : "light");
  }, [darkMode]);

  const initials = username.charAt(0).toUpperCase();

  return (
    <header className="app-header">
      <div className="header-left" onClick={() => navigate("/")}>
        <span className="brand-badge">TM</span>
        <span className="brand-text">Task Manager</span>
      </div>

      {isAuthenticated && (
        <nav className="header-nav">
          <button onClick={() => navigate(`/welcome/${username}`)}>Home</button>
          <button onClick={() => navigate("/list-todos")}>Todos</button>
        </nav>
      )}

      <div className="header-right">
        {/* Theme toggle */}
        <button
          className="theme-toggle"
          onClick={() => setDarkMode(!darkMode)}
          title="Toggle theme"
        >
          {darkMode ? "🌙" : "☀️"}
        </button>

        {isAuthenticated ? (
          <div className="avatar-wrapper">
            <div
              className="avatar"
              onClick={() => setOpenMenu(!openMenu)}
            >
              {initials}
            </div>

            {openMenu && (
              <div className="avatar-menu">
                <div className="avatar-user">
                  Signed in as <b>{username}</b>
                </div>
                <button onClick={() => navigate("/profile")}>
                  Profile
                </button>
                <button
                  className="logout"
                  onClick={() => {
                    authContext.logout();
                    navigate("/logout");
                  }}
                >
                  Logout
                </button>
              </div>
            )}
          </div>
        ) : (
          <button className="header-btn header-login" onClick={() => navigate("/")}>
            Login
          </button>
        )}
      </div>
    </header>
  );
};

export default Header;
